(function () {
  const drawer = document.querySelector('[data-monogram-drawer]');
  if (!drawer) return;

  const triggers = document.querySelectorAll('[data-monogram-trigger]');
  const closers = drawer.querySelectorAll('[data-monogram-close]');
  const nextBtn = drawer.querySelector('[data-monogram-next]');
  const prevBtn = drawer.querySelector('[data-monogram-prev]');
  const nextLabel = drawer.querySelector('[data-next-label]');
  const steps = drawer.querySelectorAll('.monogram-step[data-step]');
  const stepCircles = drawer.querySelectorAll('[data-step-circle]');
  const connectors = drawer.querySelectorAll('.monogram-stepper__connector');
  const currentLabel = drawer.querySelector('[data-current-step-label]');

  const stepLabels = {
    1: 'Estilo do Monograma',
    2: 'Iniciais',
    3: 'Cor',
    4: 'Local de Gravação'
  };

  const errorMessages = {
    1: 'Seleciona um estilo para continuar',
    2: 'Indica o número de letras e as iniciais para continuar',
    3: 'Seleciona uma cor para continuar',
    4: 'Aceita os termos para finalizar'
  };

  const TOTAL_STEPS = 4;
  let currentStep = 1;
  let previouslyFocused = null;
  // Marcado a true quando o cliente conclui o wizard (CONFIRMAR).
  // O drawer deixa de adicionar ao carrinho directamente: este flag indica
  // ao submit do form de produto (Sub-fase 3) que deve incluir o add-on.
  let isConfigured = false;

  const selections = {
    style: null,
    numLetters: null,
    initials: [],
    color: null,
    position: null,
    termsAccepted: false
  };

  // Carregar lookup tables do JSON inline
  let lookups = { colors: {}, positions: {}, styles: {}, addon: {} };
  try {
    const lookupsEl = drawer.querySelector('[data-monogram-lookups]');
    if (lookupsEl) {
      lookups = JSON.parse(lookupsEl.textContent);
    }
  } catch (e) {
    console.error('[Monogram] Failed to parse lookups:', e);
  }

  // Helpers de display name
  function getStyleName(id) {
    return lookups.styles[id] || id || '—';
  }
  function getColorName(id) {
    return lookups.colors[id] || id || '—';
  }
  function getPositionName(id) {
    return lookups.positions[id] || id || '—';
  }

  // Construtor do payload que será enviado para /cart/add.js no Prompt 4B
  function buildCartPayload() {
    const productVariantId = parseInt(drawer.dataset.productVariantId, 10);
    const productTitle = drawer.dataset.productTitle || 'Product';
    const initialsString = (selections.initials || []).join('');

    const properties = {
      '_Monogram Style ID': selections.style,
      'Monogram Style': getStyleName(selections.style),
      'Iniciais': initialsString,
      'Número de letras': selections.numLetters,
      '_Monogram Color ID': selections.color,
      'Cor do Bordado': getColorName(selections.color),
      '_Monogram Position ID': selections.position,
      'Posição': getPositionName(selections.position),
      '_Monogram Link': 'monogram-' + Date.now() // único por personalização
    };

    return {
      mainItem: {
        id: productVariantId,
        quantity: 1,
        properties: properties
      },
      addonItem: {
        id: lookups.addon.variantId,
        quantity: 1,
        properties: {
          '_Monogram Link': properties['_Monogram Link'],
          'For Product': productTitle
        }
      }
    };
  }

  function hideError(stepNumber) {
    const errorEl = drawer.querySelector('[data-step="' + stepNumber + '"] [data-step-error]');
    if (errorEl) errorEl.hidden = true;
  }

  function showError(step, message) {
    const errorEl = drawer.querySelector('[data-step="' + step + '"] [data-step-error]');
    if (errorEl) {
      errorEl.textContent = message || errorMessages[step] || 'Erro';
      errorEl.removeAttribute('hidden');
    }
  }

  // Mapeia a resposta de erro do Shopify (em inglês) para mensagem PT clara.
  // Classificação por keywords: o nome/handle do add-on é "monogram-personalization",
  // por isso descrições que mencionem monograma/personalization apontam para o add-on.
  function getFriendlyError(errorData) {
    const raw = (errorData && (errorData.description || errorData.message)) || '';
    const lower = raw.toLowerCase();
    if (lower.indexOf('monogram') !== -1 || lower.indexOf('personalization') !== -1 || lower.indexOf('personalizacao') !== -1) {
      return 'Personalização temporariamente indisponível. Tenta de novo em instantes ou contacta-nos.';
    }
    if (lower.indexOf('out of stock') !== -1 || lower.indexOf('sold out') !== -1 ||
        lower.indexOf('not enough') !== -1 || lower.indexOf('no more available') !== -1 ||
        lower.indexOf('unavailable') !== -1 || lower.indexOf('insufficient') !== -1 ||
        lower.indexOf('inventory') !== -1 || lower.indexOf('stock') !== -1) {
      return 'Este produto está esgotado de momento.';
    }
    return 'Não foi possível adicionar ao carrinho. Tenta de novo em instantes.';
  }

  async function addToCart(payload) {
    let response;
    try {
      response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          // Ambos numa só chamada: /cart/add.js é atómico — se um falhar, nenhum entra
          items: [payload.mainItem, payload.addonItem]
        })
      });
    } catch (networkError) {
      console.error('[Monogram] addToCart network failure:', networkError);
      throw new Error('Erro de ligação. Verifica a tua internet e tenta de novo.');
    }

    if (!response.ok) {
      let errorData = {};
      try { errorData = await response.json(); } catch (e) { /* resposta sem JSON parseável */ }
      console.error('[Monogram] addToCart HTTP error:', response.status, errorData);
      throw new Error(getFriendlyError(errorData));
    }

    return await response.json();
  }

  function isStepValid(step) {
    switch (step) {
      case 1: return selections.style !== null;
      case 2: return selections.numLetters !== null &&
                     selections.initials.length === selections.numLetters &&
                     selections.initials.every(function (l) { return /^[A-ZÀ-Ÿ]$/.test(l); });
      case 3: return selections.color !== null;
      case 4: return selections.position !== null && selections.termsAccepted;
      default: return false;
    }
  }

  function updateNextButton() {
    nextBtn.disabled = !isStepValid(currentStep);
  }

  function updateStepperVisual(stepNumber) {
    stepCircles.forEach(function (c) {
      const n = parseInt(c.dataset.stepCircle, 10);
      c.classList.toggle('is-active', n === stepNumber);
      c.classList.toggle('is-completed', n < stepNumber);
    });
    connectors.forEach(function (con, idx) {
      // connector idx 0 conecta círculo 1->2, idx 1 -> 2->3, idx 2 -> 3->4
      con.classList.toggle('is-completed', idx + 1 < stepNumber);
    });
  }

  function showStep(stepNumber) {
    steps.forEach(function (s) {
      const isActive = parseInt(s.dataset.step, 10) === stepNumber;
      s.hidden = !isActive;
      s.classList.toggle('monogram-step--active', isActive);
    });
    updateStepperVisual(stepNumber);
    if (currentLabel) currentLabel.textContent = stepLabels[stepNumber];
    prevBtn.hidden = (stepNumber === 1);
    nextLabel.textContent = (stepNumber === TOTAL_STEPS) ? 'CONFIRMAR' : 'PRÓXIMO ›';
    hideError(stepNumber);
    currentStep = stepNumber;
    if (stepNumber === 2) syncStep2UI();
    if (stepNumber === 3) syncStep3UI();
    if (stepNumber === 4) syncStep4UI();
    updateNextButton();

    const activeStep = drawer.querySelector('.monogram-step[data-step="' + stepNumber + '"]');
    if (activeStep) {
      const firstFocusable = activeStep.querySelector('button, input, select, [tabindex]:not([tabindex="-1"])');
      if (firstFocusable) firstFocusable.focus();
    }
  }

  // Reflecte o estado isConfigured no trigger (checkmark visual + aria-pressed
   // semântico). aria-pressed funciona como toggle button para a Sub-fase 2.
  function updateTriggerCheckbox() {
    triggers.forEach(function (t) {
      t.setAttribute('aria-pressed', isConfigured ? 'true' : 'false');
      const box = t.querySelector('[data-monogram-checkbox]');
      if (box) box.classList.toggle('is-checked', isConfigured);
    });
    updateMonogramCard();
  }

  // Cartão de resumo acima do ADD TO CART: visível só quando configurado.
  // Preenche preview (SVG do estilo via data-image-url já calculado pelo Liquid)
  // e a linha de detalhes (estilo; iniciais; cor; posição).
  function updateMonogramCard() {
    const card = document.querySelector('[data-monogram-summary-card]');
    if (!card) return;

    if (!isConfigured) {
      card.setAttribute('hidden', '');
      return;
    }

    const previewImg = card.querySelector('[data-monogram-summary-preview]');
    if (previewImg && selections.style) {
      const styleItem = document.querySelector('[data-style-id="' + selections.style + '"]');
      const imageUrl = styleItem ? styleItem.dataset.imageUrl : '';
      if (imageUrl) {
        previewImg.src = imageUrl;
        previewImg.alt = getStyleName(selections.style);
      }
    }

    const detailsEl = card.querySelector('[data-monogram-summary-details]');
    if (detailsEl) {
      const initials = (selections.initials || []).join('');
      const parts = [
        getStyleName(selections.style),
        initials,
        getColorName(selections.color),
        getPositionName(selections.position)
      ].filter(Boolean);
      detailsEl.textContent = parts.join('; ') + ';';
    }

    card.removeAttribute('hidden');
  }

  function resetDrawerState() {
    selections.style = null;
    selections.numLetters = null;
    selections.initials = [];
    selections.color = null;
    selections.position = null;
    selections.termsAccepted = false;
    drawer.querySelectorAll('.monogram-style-item, .monogram-letter-option, .monogram-color-item, .monogram-position-item').forEach(function (item) {
      item.classList.remove('is-selected');
    });
    drawer.querySelectorAll('[data-monogram-style], [data-num-letters], [data-monogram-color], [data-monogram-position]').forEach(function (input) {
      input.checked = false;
    });
    const termsCheck = drawer.querySelector('[data-monogram-terms]');
    if (termsCheck) termsCheck.checked = false;
    const initialsContainer = drawer.querySelector('[data-initials-container]');
    if (initialsContainer) initialsContainer.innerHTML = '';
  }

  function handleNext() {
    if (currentStep < TOTAL_STEPS) {
      showStep(currentStep + 1);
      return;
    }
    // Branch CONFIRMAR: deixa de chamar /cart/add.js.
    // Só marca o flag, reflecte na checkbox do trigger, e fecha o drawer.
    // selections + currentStep persistem em memória — ao reabrir, vê-se o passo 4.
    // O envio para o carrinho passa a ser feito pelo submit do form de produto (Sub-fase 3).
    isConfigured = true;
    updateTriggerCheckbox();
    closeDrawer();
  }

  function handlePrev() {
    if (currentStep > 1) {
      showStep(currentStep - 1);
    }
  }

  function openDrawer() {
    previouslyFocused = document.activeElement;
    drawer.removeAttribute('hidden');
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
    });
    document.body.style.overflow = 'hidden';
    showStep(currentStep);
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () {
      drawer.setAttribute('hidden', '');
      if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
        previouslyFocused.focus();
      }
    }, 300);
  }

  // Click no trigger:
  //  - isConfigured=true  → toggle off (desmarca, mantém selections em memória)
  //  - isConfigured=false + selections já guardadas → re-marca sem abrir drawer
  //  - sem selections (estado inicial) → abre o drawer
  function handleTriggerClick() {
    if (isConfigured) {
      isConfigured = false;
      updateTriggerCheckbox();
      return;
    }
    if (selections.style !== null) {
      isConfigured = true;
      updateTriggerCheckbox();
      return;
    }
    openDrawer();
  }

  triggers.forEach(function (t) {
    t.addEventListener('click', handleTriggerClick);
  });

  // Acções do cartão de resumo (substituem o antigo link "Editar monograma").
  const cardRemoveBtn = document.querySelector('[data-monogram-summary-remove]');
  if (cardRemoveBtn) {
    cardRemoveBtn.addEventListener('click', function () {
      if (window.confirm('Tens a certeza que queres remover a personalização?')) {
        window.monogramAPI.clear();
      }
    });
  }

  // "Alterar Personalização" reabre o drawer no passo 4 com a config visível.
  const cardEditBtn = document.querySelector('[data-monogram-summary-edit]');
  if (cardEditBtn) {
    cardEditBtn.addEventListener('click', function (e) {
      e.preventDefault();
      openDrawer();
      showStep(TOTAL_STEPS);
    });
  }

  closers.forEach(function (c) {
    c.addEventListener('click', closeDrawer);
  });

  nextBtn.addEventListener('click', handleNext);
  prevBtn.addEventListener('click', handlePrev);

  // Recolhe os elementos focáveis dentro do drawer. Exclui:
  //  - elementos com [hidden] directo ou herdado de algum ancestral (steps inactivos)
  //  - radios duplicados dentro do mesmo grupo: por grupo, mantém apenas o seleccionado
  //    (ou o primeiro, se nenhum estiver seleccionado), reproduzindo o padrão nativo
  //    de radio groups (Tab entra/sai do grupo; setas alternam dentro)
  function getFocusableElements() {
    const selector = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    const all = Array.from(drawer.querySelectorAll(selector)).filter(function (el) {
      if (el.hasAttribute('hidden')) return false;
      let parent = el.parentElement;
      while (parent && parent !== drawer) {
        if (parent.hasAttribute('hidden')) return false;
        parent = parent.parentElement;
      }
      return true;
    });

    const radioGroupRepresentative = {};
    all.forEach(function (el) {
      if (el.type !== 'radio' || !el.name) return;
      const current = radioGroupRepresentative[el.name];
      if (!current) {
        radioGroupRepresentative[el.name] = el;
      } else if (!current.checked && el.checked) {
        radioGroupRepresentative[el.name] = el;
      }
    });

    return all.filter(function (el) {
      if (el.type === 'radio' && el.name) {
        return radioGroupRepresentative[el.name] === el;
      }
      return true;
    });
  }

  document.addEventListener('keydown', function (e) {
    if (!drawer.classList.contains('is-open')) return;

    if (e.key === 'Escape') {
      closeDrawer();
      return;
    }

    // Focus trap agressivo: intercepta SEMPRE o Tab e movimenta o foco
    // manualmente dentro do drawer, para o foco nunca poder escapar (ex.
    // quando o CONFIRMAR está disabled e o browser tentava pular para fora).
    if (e.key === 'Tab') {
      const focusable = getFocusableElements();
      if (focusable.length === 0) {
        e.preventDefault();
        return;
      }
      e.preventDefault();
      const active = document.activeElement;
      let idx = focusable.indexOf(active);
      if (idx === -1) {
        focusable[e.shiftKey ? focusable.length - 1 : 0].focus();
        return;
      }
      let nextIdx = e.shiftKey ? idx - 1 : idx + 1;
      if (nextIdx < 0) nextIdx = focusable.length - 1;
      if (nextIdx >= focusable.length) nextIdx = 0;
      focusable[nextIdx].focus();
    }
  });

  function renderInitialInputs(n) {
    const container = drawer.querySelector('[data-initials-container]');
    container.innerHTML = '';
    const labels = ['Inicial 1', 'Inicial 2', 'Inicial 3'];
    for (let i = 0; i < n; i++) {
      const field = document.createElement('div');
      field.className = 'monogram-initial-field';
      field.innerHTML =
        '<span class="monogram-initial-field__label">' + labels[i] + '</span>' +
        '<input type="text" maxlength="1" pattern="[A-Za-zÀ-ÿ]" class="monogram-initial-field__input" data-initial-index="' + i + '" placeholder="A">';
      container.appendChild(field);
    }
    const inputs = Array.from(container.querySelectorAll('[data-initial-index]'));
    inputs.forEach(function (input) {
      input.addEventListener('input', function (e) {
        const idx = parseInt(e.target.dataset.initialIndex, 10);
        selections.initials[idx] = e.target.value.toUpperCase().slice(0, 1);
        e.target.value = selections.initials[idx];
        if (selections.initials[idx] && idx < inputs.length - 1) {
          inputs[idx + 1].focus();
        }
        updateNextButton();
      });
      input.addEventListener('keydown', function (e) {
        const idx = parseInt(e.target.dataset.initialIndex, 10);
        if (e.key === 'Backspace' && e.target.value === '' && idx > 0) {
          inputs[idx - 1].focus();
        }
      });
    });
  }

  function syncStep2UI() {
    if (selections.numLetters === null) return;
    const radio = drawer.querySelector('[data-num-letters][value="' + selections.numLetters + '"]');
    if (radio) {
      radio.checked = true;
      radio.closest('.monogram-letter-option').classList.add('is-selected');
    }
    renderInitialInputs(selections.numLetters);
    selections.initials.forEach(function (val, idx) {
      const input = drawer.querySelector('[data-initial-index="' + idx + '"]');
      if (input && val) input.value = val;
    });
  }

  function syncStep4UI() {
    if (selections.position !== null) {
      const radio = drawer.querySelector('[data-monogram-position][value="' + selections.position + '"]');
      if (radio) {
        radio.checked = true;
        radio.closest('.monogram-position-item').classList.add('is-selected');
      }
    }
    const termsCheck = drawer.querySelector('[data-monogram-terms]');
    if (termsCheck) termsCheck.checked = selections.termsAccepted;
  }

  function syncStep3UI() {
    if (selections.color === null) return;
    const radio = drawer.querySelector('[data-monogram-color][value="' + selections.color + '"]');
    if (radio) {
      radio.checked = true;
      radio.closest('.monogram-color-item').classList.add('is-selected');
    }
  }

  const colorRadios = drawer.querySelectorAll('[data-monogram-color]');
  colorRadios.forEach(function (radio) {
    radio.addEventListener('change', function (e) {
      selections.color = e.target.value;
      drawer.querySelectorAll('.monogram-color-item').forEach(function (item) {
        item.classList.remove('is-selected');
      });
      e.target.closest('.monogram-color-item').classList.add('is-selected');
      updateNextButton();
    });
  });

  const positionRadios = drawer.querySelectorAll('[data-monogram-position]');
  positionRadios.forEach(function (radio) {
    radio.addEventListener('change', function (e) {
      selections.position = e.target.value;
      drawer.querySelectorAll('.monogram-position-item').forEach(function (item) {
        item.classList.remove('is-selected');
      });
      e.target.closest('.monogram-position-item').classList.add('is-selected');
      updateNextButton();
    });
  });

  const termsCheckbox = drawer.querySelector('[data-monogram-terms]');
  if (termsCheckbox) {
    termsCheckbox.addEventListener('change', function (e) {
      selections.termsAccepted = e.target.checked;
      updateNextButton();
    });
  }

  const numLettersRadios = drawer.querySelectorAll('[data-num-letters]');
  numLettersRadios.forEach(function (radio) {
    radio.addEventListener('change', function (e) {
      const n = parseInt(e.target.value, 10);
      selections.numLetters = n;
      selections.initials = new Array(n).fill('');
      drawer.querySelectorAll('.monogram-letter-option').forEach(function (opt) {
        opt.classList.remove('is-selected');
      });
      e.target.closest('.monogram-letter-option').classList.add('is-selected');
      renderInitialInputs(n);
      updateNextButton();
    });
  });

  const styleRadios = drawer.querySelectorAll('[data-monogram-style]');
  styleRadios.forEach(function (radio) {
    radio.addEventListener('change', function (e) {
      selections.style = e.target.value;
      drawer.querySelectorAll('.monogram-style-item').forEach(function (item) {
        item.classList.remove('is-selected');
      });
      e.target.closest('.monogram-style-item').classList.add('is-selected');
      updateNextButton();
    });
  });

  // API pública — consumida pelo interceptor do submit do form de produto
  // (Sub-fase 3) e por outros scripts que precisem de saber se o monograma
  // está configurado nesta sessão. Não persiste entre refreshes (closure).
  window.monogramAPI = {
    isConfigured: function () { return isConfigured; },
    getSelections: function () { return isConfigured ? Object.assign({}, selections) : null; },
    getPayload: function () { return isConfigured ? buildCartPayload() : null; },
    clear: function () {
      isConfigured = false;
      resetDrawerState();
      currentStep = 1;
      updateTriggerCheckbox();
      updateMonogramCard();
    }
  };
})();

/* ============================================================
   Interceptor do submit do <product-form> do tema (Sub-fase 7.3)
   ============================================================
   Quando o monograma está configurado, intercepta o ADD TO CART do tema
   antes do listener nativo do Prestige (capture phase) e envia o produto
   principal + add-on numa só chamada atómica. Caso contrário, deixa o
   tema processar normalmente.
*/
(function () {
  function init() {
    // Listener no <product-form> (ancestor) em capture phase: garante prioridade
    // sobre o listener nativo do Prestige (registado no form filho em bubble),
    // porque listeners de capture phase em ancestrais correm sempre antes da
    // target phase no form, independentemente da ordem de registo.
    const productFormEl = document.querySelector('product-form');
    if (!productFormEl) return;

    const productForm = productFormEl.querySelector('form[action*="/cart/add"]');
    if (!productForm) return;

    productFormEl.addEventListener('submit', async function (event) {
      if (!window.monogramAPI || !window.monogramAPI.isConfigured()) {
        return; // Sem monograma activo → comportamento normal do tema
      }

      // Anti-double-submit: o Prestige usa aria-busy no submitter
      if (event.submitter && event.submitter.getAttribute('aria-busy') === 'true') {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation(); // impede o onSubmit_fn nativo

      const payload = window.monogramAPI.getPayload();
      if (!payload) return;

      // Variant ID actualizado: cobre o caso de o cliente trocar de tamanho
      // depois de ter configurado o monograma. O <input name="id"> reflecte
      // sempre a variante seleccionada.
      const variantInput = productForm.querySelector('[name="id"]');
      if (variantInput && variantInput.value) {
        payload.mainItem.id = parseInt(variantInput.value, 10);
      }

      const submitButtons = Array.from(productForm.elements).filter(function (el) {
        return el.type === 'submit';
      });
      submitButtons.forEach(function (btn) { btn.setAttribute('aria-busy', 'true'); });
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

      try {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

        // Recolhe sections que precisam de re-renderizar (cart-drawer, contador, etc).
        // O tema responde a este evento empurrando IDs para o array.
        // Sem isto, o /cart/add.js devolve só o item adicionado e o cart-drawer
        // fica preso no estado anterior — origem do bug "está sempre 1 passo atrás".
        const sectionsToBundle = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle }
        }));

        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: [payload.mainItem, payload.addonItem],
            sections: sectionsToBundle.join(','),
            sections_url: root + 'variants/' + payload.mainItem.id
          })
        });

        if (!response.ok) {
          let errorData = {};
          try { errorData = await response.json(); } catch (e) { /* sem corpo */ }
          throw new Error(errorData.description || errorData.message || 'Erro ao adicionar ao carrinho.');
        }

        const responseJson = await response.json();
        const cartContent = await (await fetch(root + 'cart.js')).json();
        // Anexa o HTML pré-renderizado das sections (incluindo o cart-drawer)
        // ao cart antes do dispatch — o tema usa isto para substituir o conteúdo.
        cartContent.sections = responseJson.sections;

        // Limpa o estado do monograma (desmarca checkbox, esconde "Editar", reset selections)
        window.monogramAPI.clear();

        // Replica o evento que o Prestige dispara em onSubmit_fn —
        // o cart-drawer reage a isto para abrir e re-renderizar com o cart actual.
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: {
            baseEvent: 'variant:add',
            cart: cartContent
          }
        }));

      } catch (error) {
        console.error('[Monogram form-intercept] add to cart failed:', error);
        // Banner inline gerido por <buy-buttons> via cart:error
        productForm.dispatchEvent(new CustomEvent('cart:error', {
          bubbles: true,
          detail: { error: error.message || 'Erro ao adicionar ao carrinho.' }
        }));
      } finally {
        submitButtons.forEach(function (btn) { btn.removeAttribute('aria-busy'); });
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
      }
    }, true); // capture phase — corre antes do listener nativo do <product-form>
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
